export type Feedback = { tone: "success" | "error" | "info"; message: string };
type Listener = (feedback: Feedback) => void;
const listeners = new Set<Listener>();
const deliveredErrors = new WeakSet<object>();

/** UI feedback survives route changes; loading and field errors stay local. */
export function subscribeFeedback(listener: Listener): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

function publish(tone: Feedback["tone"], message: string) {
  for (const listener of listeners) listener({ tone, message });
}

export const notify = {
  success: (message: string) => publish("success", message),
  error: (message: string) => publish("error", message),
  info: (message: string) => publish("info", message),
};

export function notifyFailure(error: Error): void {
  if (!listeners.size || deliveredErrors.has(error)) return;
  deliveredErrors.add(error);
  notify.error(error.message);
}

export function wasNotified(error: unknown): boolean {
  return typeof error === "object" && error !== null && deliveredErrors.has(error);
}
